import { render, staticRenderFns } from "./news.vue?vue&type=template&id=0ca660d6&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&id=0ca660d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca660d6",
  null
  
)

export default component.exports